import { combineReducers } from 'redux'
import { prefixAction } from '../helpers'

export const SORTABLE_SORT_BY = 'SORTABLE_SORT_BY'
export const SORTABLE_TOGGLE_ORDER = 'SORTABLE_TOGGLE_ORDER'
export const SORTABLE_UPDATE_PROP = 'SORTABLE_UPDATE_PROP'
export const SORTABLE_PROPERTY_ORDER = 'SORTABLE_PROPERTY_ORDER'
export const SORTABLE_VISIBILITY_TOGGLE = 'SORTABLE_VISIBILITY_TOGGLE'
export const SORTABLE_EDITABLE = 'SORTABLE_EDITABLE'

const cols = (prefix, cols) => (state = cols, { type, payload }) => {
  if (type === prefixAction(prefix, SORTABLE_VISIBILITY_TOGGLE)) {
    return [...payload.cols]
  }
  return state
}

const order = (prefix, order) => (state = order, { type, payload }) => {
  switch (type) {
    case prefixAction(prefix, SORTABLE_TOGGLE_ORDER):
    case prefixAction(prefix, SORTABLE_SORT_BY):
      return payload.order
    default:
      return state
  }
}

const sortBy = (prefix, sortBy) => (state = sortBy, { type, payload }) => {
  if (type === prefixAction(prefix, SORTABLE_SORT_BY)) {
    return payload.sortBy
  }
  return state
}

export default function sortableReducerFactory(path, state) {
  const defaultState = { ...{ cols: ['id'], order: 'asc', sortBy: 'id' }, ...state }
  return combineReducers({
    cols: cols(path, defaultState.cols),
    order: order(path, defaultState.order),
    sortBy: sortBy(path, defaultState.sortBy)
  })
}
